import { Component, OnInit } from '@angular/core';
declare var $: any;
@Component({
  selector: 'app-nd-cancellation-policy',
  templateUrl: './nd-cancellation-policy.component.html',
  styleUrls: ['./nd-cancellation-policy.component.css']
})
export class NdCancellationPolicyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {

    if($(window).width() >= 992){
      $('#nd-home').removeClass('active');
      $('#nd-abt').removeClass('active');
      $('#nd-faq').removeClass('active');
      $('#nd-cact').removeClass('active');
      $('#nd-okto').removeClass('active');
      }

  }

}
